(function($){
	OH.settings.standbyControl = (function(){
		var carouselSerial = 0;
		var control = new Object();
		
		control.intoview = function($element){
			var type = $element.data("intoview");
			var done = false;
			var afterIntoView = function(){
				if(!done){
					done = true;
					OH.settings.standbyDefine[type]($element);
				}
			};
			var onScroll = function(){
				if($element.offset().top + $element.height() < $(window).height() + $(window).scrollTop()){
					afterIntoView();
					$(window).off("scroll", onScroll);
				}
			};
			$(window).on("load scroll", onScroll);
		};

		return control;
	})();
})(jQuery);
